import {Controller} from "@hotwired/stimulus";

// A copy that is lost (still queued, or its worker stopped) sends no answer, so the overlay says so.
const CLONE_WAIT_MS = 3 * 60 * 1000;

export default class extends Controller {
    static targets = ["deleteOverlay", "cloneOverlay", "cloneWaiting", "cloneStuck"]

    disconnect() {
        clearTimeout(this.cloneTimer);
    }

    showDelete(event) {
        if (confirm("Are you sure you want to delete this?")) {
            const turboFrame = document.getElementById(event.currentTarget.dataset.target);
            turboFrame.classList.add("hidden");
            this.deleteOverlayTarget.classList.remove("hidden");
        } else {
            event.preventDefault()
        }
    }

    showClone(event) {
        if (confirm("Are you sure?")) {
            let onlyClone = event.currentTarget.dataset.onlyClone;

            if (!onlyClone) {
                const turboFrame = document.getElementById(event.currentTarget.dataset.target);
                turboFrame.classList.add("hidden");
            }

            this.cloneOverlayTarget.classList.remove("hidden");
            clearTimeout(this.cloneTimer);
            this.cloneTimer = setTimeout(() => this.showCloneStuck(), CLONE_WAIT_MS);
        } else {
            event.preventDefault();
        }
    }

    // No target: a page without the notice (Data Builder), or the job already replaced it with its failure.
    showCloneStuck() {
        if (!this.hasCloneStuckTarget) return;

        this.cloneWaitingTarget.classList.add("hidden");
        this.cloneStuckTarget.classList.remove("hidden");
    }



    showLoader(event) {
        if (event.target.checked) {
            const reportsLoader = this.element.querySelector('#reports_loader')
            const hiddenLoader = this.element.querySelector('#hidden_loader')
            reportsLoader.innerHTML = hiddenLoader.innerHTML
        }
    }


}
